import styled from 'styled-components';
import { useTranslation } from '../../utils/useTranslation';
import { IconLike } from '../icon/IconLike';
import { IconPlus } from '../icon/IconPlus';
import { IconShare } from '../icon/IconShare';
import { Button } from '../input/Button';
import { Box } from '../layout/Box';
import { Flex } from '../layout/Flex';
import { CollectionStatus, CollectionUI } from '../users/types';

const DEFAULT_COLLECTION_ID = '-1';

const FixedContainer = styled(Box).attrs({
    width: '100%',
})`
    background-color: color-mix(in srgb, var(--background-primary) 65%, transparent);
    -webkit-backdrop-filter: blur(--blur-radius-l);
    backdrop-filter: blur(var(--blur-radius-l));
    transition-property: background-color, backdrop-filter;
    transition-duration: 250ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    box-sizing: border-box;
    position: sticky;
    bottom: 0;
    left: 0;
    transform: translate3d(0, 0, 0);
`;

const getButtons = (
    collection: CollectionUI,
    onShare?: VoidFunction,
    onReaction?: VoidFunction,
    onShowAddPostDialog?: VoidFunction,
) => {
    const t = useTranslation();

    if (collection.modifiable) {
        if (collection.status === CollectionStatus.PUBLISHED && collection.isPublic) {
            return (
                <Flex
                    direction="row"
                    width="100%"
                    alignItems="center"
                    justifyContent="space-between"
                    p={2}
                    spacing={0.5}
                >
                    <Button color="secondary" width="50%" spacing={1} onClick={onShare}>
                        <IconShare size={16} />
                        {t('Поделиться')}
                    </Button>
                    <Button color="secondary" width="50%" spacing={1} onClick={onShowAddPostDialog}>
                        <IconPlus size={16} />
                        {t('Добавить пост')}
                    </Button>
                </Flex>
            );
        } else {
            return (
                <Flex
                    direction="row"
                    width="100%"
                    alignItems="center"
                    justifyContent="space-between"
                    p={2}
                    spacing={0.5}
                >
                    <Button
                        color="secondary"
                        width="100%"
                        spacing={1}
                        onClick={onShowAddPostDialog}
                    >
                        <IconPlus size={16} />
                        {t('Добавить пост')}
                    </Button>
                </Flex>
            );
        }
    } else {
        return (
            <Flex
                direction="row"
                width="100%"
                alignItems="center"
                justifyContent="space-between"
                p={2}
                spacing={0.5}
            >
                <Button color="secondary" width="50%" spacing={1} onClick={onShare}>
                    <IconShare size={16} />
                    {t('Поделиться')}
                </Button>
                <Button color="secondary" width="50%" spacing={1} onClick={onReaction}>
                    <IconLike
                        size={16}
                        strokeWidth="2px"
                        stroke="var(--color-primary)"
                        fill={collection.isLiked ? 'var(--color-primary)' : 'transparent'}
                    />
                    {t('Нравится')}
                </Button>
            </Flex>
        );
    }
};

interface StickyFooterProps {
    collection: CollectionUI;
    onShare?: VoidFunction;
    onReaction?: VoidFunction;
    onShowAddPostDialog?: VoidFunction;
}

export const StickyFooter = (props: StickyFooterProps) => {
    const { collection, onShare, onReaction, onShowAddPostDialog } = props;

    if (
        collection.id === DEFAULT_COLLECTION_ID ||
        (!collection.modifiable &&
            (!collection.isPublic || collection.status !== CollectionStatus.PUBLISHED))
    ) {
        return <></>;
    }

    return (
        <FixedContainer mb={{ sm: -2 }}>
            {getButtons(collection, onShare, onReaction, onShowAddPostDialog)}
        </FixedContainer>
    );
};
